import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Api from '../../../../../constants/Api';
import axiosInstance from '../../../../../services/AxiosInstance';
import CustomSelect from '../../../Forms/Element/CustomSelect';

/**
 * Componente responsável por listar os planos.
 */
const PlanSelect = (props) => {

  const { t } = useTranslation();
  const [entities, setEntities] = useState([]);

  function findAll() {
    axiosInstance.get(Api.subscription.plan)
      .then(response => {
        const data = response.data?.content || response.data || [];
        // O que o plano oferece (usos, ciclos e produtos) viaja junto da opção para
        // o PlanDetails mostrar sem uma segunda chamada ao selecionar.
        const entities = data.map((plan) => ({
          value: plan.id,
          label: plan.name,
          price: plan.price ?? plan.creditCardPrice,
          periodicity: plan.periodicity,
          packageDays: plan.packageDays,
          qtyTransactions: plan.qtyTransactions,
          maxAppointments: plan.maxAppointments,
          planProducts: plan.planProducts || []
        }));

        setEntities(entities);
      });
  }

  useEffect(() => {
    findAll();
  }, []);

  return (
    <CustomSelect options={entities} value={props.value} onChange={props.onChange} isClearable placeholder={t("select")}/>
  )
}

export default PlanSelect;
